export default {
  title: "404",
  subtitle: "Page not found",
  description: "The data or the page you're looking for doesn't exist :("
}